import { useRef } from "react";
import { Layout, Smile, BookMarked, User, ChevronLeft, ChevronRight } from "lucide-react";
import { EffectCoverflow, Mousewheel } from "swiper/modules";
import type { Swiper as SwiperClass } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import useScroll from "../../hooks/useScroll";
import { listProduct } from "../../utilities/objects";
import StatsCard from "../common/Card/StatsCard";
import ResponsiveImage from "../common/ResponsiveImage";
import TitleSecond from "../common/TitlesSecond";

const SectionProject = () => {
  const { scrollRef, handleMouseEnter, handleMouseLeave } = useScroll();
  const swiperRef = useRef<SwiperClass | null>(null);

  return (
    <section className="mt-10 overflow-hidden pb-4 md:pb-8">
      <div className="container flex w-full flex-col items-center justify-center">
        <TitleSecond>Thành tựu và dự án thực tế của TrioCore Solutions</TitleSecond>
        <p className="mt-4 max-w-3xl px-2 text-center text-sm font-normal leading-7 text-slate-600 md:text-base">
          Những con số dưới đây phản ánh các dự án đã triển khai, mức độ hài lòng của khách hàng
          và năng lực thực thi mà TrioCore Solutions tích lũy qua từng giai đoạn đồng hành.
        </p>

        <div className="mt-8 w-full md:mt-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[14px] w-full justify-items-center">
            <StatsCard
              title="Khách hàng"
              value="200"
              icon={<User color="#DC2626" className="color-main" size={56} />}
            />
            <StatsCard
              title="Mức độ hài lòng"
              value="90"
              icon={<Smile color="#DC2626" className="color-main" size={56} />}
            />
            <StatsCard
              title="Thiết kế"
              value="200"
              icon={<Layout color="#DC2626" className="color-main" size={56} />}
            />
            <StatsCard
              title="Dự án thực tế"
              value="100"
              icon={<BookMarked color="#DC2626" className="color-main" size={56} />}
            />
          </div>
        </div>

        <div className="relative mt-8 flex w-full items-center justify-center md:mt-10">
          <button
            type="button"
            aria-label="Xem slide trước"
            onClick={() => swiperRef.current?.slidePrev()}
            className="absolute left-1 top-1/2 z-20 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-red-100 bg-white text-red-600 shadow-[0_10px_24px_rgba(127,29,29,0.12)] transition-transform duration-200 hover:-translate-x-0.5 hover:scale-105 md:left-[-18px] md:flex lg:left-[-26px]"
          >
            <ChevronLeft size={18} strokeWidth={2.4} />
          </button>

          <Swiper
            modules={[EffectCoverflow, Mousewheel]}
            effect="coverflow"
            grabCursor
            centeredSlides
            slidesPerView="auto"
            loop
            watchSlidesProgress
            mousewheel
            slideToClickedSlide
            speed={1500}
            onSwiper={(swiper: SwiperClass) => {
              swiperRef.current = swiper;
            }}
            coverflowEffect={{
              rotate: 16,
              stretch: 68,
              depth: 100,
              slideShadows: true,
            }}
            className="swiper-bottom h-[340px] w-full max-w-[1220px] sm:h-[380px] lg:h-[400px]"
          >
            {listProduct.map((item, i) => (
              <SwiperSlide
                key={i}
                style={{ width: 260, height: 340 }}
                className="hide-scrollbar overflow-y-auto rounded-xl sm:!w-[280px] sm:!h-[400px] lg:!w-[300px] lg:!h-[450px]"
              >
                <div
                  className="hide-scrollbar h-[340px] w-[260px] overflow-y-auto rounded-xl border border-red-100 bg-white shadow-logo-spin sm:h-[400px] sm:w-[280px] lg:h-[450px] lg:w-[300px]"
                  ref={(el) => {
                    scrollRef.current[i] = el;
                  }}
                  onMouseEnter={() => handleMouseEnter(i)}
                  onMouseLeave={() => handleMouseLeave(i)}
                >
                  <ResponsiveImage src={item.img} alt={item.name} className="w-full object-cover" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            type="button"
            aria-label="Xem slide tiếp theo"
            onClick={() => swiperRef.current?.slideNext()}
            className="absolute right-1 top-1/2 z-20 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-red-100 bg-white text-red-600 shadow-[0_10px_24px_rgba(127,29,29,0.12)] transition-transform duration-200 hover:translate-x-0.5 hover:scale-105 md:right-[-18px] md:flex lg:right-[-26px]"
          >
            <ChevronRight size={18} strokeWidth={2.4} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default SectionProject;
